module.exports = __webpack_public_path__ + "img/20190731162304376.1e73085b.png";